import { ArticleSearchConditionInput } from '@/features/analyze/types';
import { SupportedLanguage } from '@/lib/i18n/config';
import { axios } from '@/lib/axios';

// バックエンドのAPI仕様に合わせた型定義
export type DownloadRequest = {
  condition: ArticleSearchConditionInput;
  limit: number;
  offset: number;
  lang: SupportedLanguage;
};

export const postDownloadArticle = (
  request: DownloadRequest
): Promise<Blob> => {
  return axios.post(
    '/api/v1/articles/download',
    {
      download: request,
    },
    {
      responseType: 'blob',
    }
  );
};
